import { Group, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { snakeCase } from 'lodash';
import { RuleConditions, RuleParameters } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { PhysiologicalValueField } from './PhysiologicalValueField';

export const PhysiologicalParameterThresholdFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, setFieldValue, errors } = useCreateRuleFormContext();

  const dataField = 'data.physiologicalParameterThreshold';

  const handleParameterChange = (value: string | null) => {
    if (!value) return;
    setFieldValue(`${dataField}.parameter`, value);
    setFieldValue(`${dataField}.threshold`, undefined);
  };

  return (
    <>
      <Group justify={'flex-start'}>
        <Select
          label={t('parameter_label')}
          data={Object.values(RuleParameters)
            .filter((value) => ![RuleParameters.heartRate].includes(value))
            .map((value) => ({
              value,
              label: t(`${snakeCase(value)}_label`),
            }))}
          placeholder={t('select_parameter_label')}
          {...getInputProps(`${dataField}.parameter`)}
          onChange={handleParameterChange}
          disabled={values.formDisabled}
          error={displayFormError({ errors, dataField: `${dataField}.parameter`, label: t('empty_value_select') })}
        />
      </Group>
      <Group gap={'md'} align={'flex-start'}>
        <Select
          label={t('condition_label')}
          {...getInputProps(`${dataField}.condition`)}
          data={Object.values(RuleConditions).map((value) => ({
            value,
            label: t(`${value}_label`),
          }))}
          w={130}
          disabled={!getInputProps(`${dataField}.parameter`).value || values.formDisabled}
        />
        <PhysiologicalValueField dataField={dataField} fieldName={'threshold'} />
      </Group>
    </>
  );
};
